import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromDataset from './dataset.reducer';
import { ManagementModuleState } from '../';

export interface DatasetState {
  datasets: fromDataset.State;
}

const selectManagementModuleState = createFeatureSelector<ManagementModuleState>('management');

const selectDatasetState = createSelector(selectManagementModuleState, (state: ManagementModuleState) => state?.datasets);

export const selectDatasets = createSelector(selectDatasetState, fromDataset.selectAll);

export const selectQueryParams = createSelector(selectDatasetState, fromDataset.getQueryParams);

export const selectQueryParamsList = createSelector(selectDatasetState, fromDataset.getQueryParamsList);

export const selectDatasetForDelete = createSelector(selectDatasetState, fromDataset.getDatasetForDelete);

export const selectSelectedDataset = createSelector(selectDatasetState, fromDataset.getSelectedDataset);

export const selectPinImages = createSelector(selectDatasetState, fromDataset.getPinImages);

export const selectShowDatasetProperties = createSelector(selectDatasetState, fromDataset.getShowDatasetProperties);

export const selectIsDatasetPropertiesEditMode = createSelector(selectDatasetState, fromDataset.getIsDatasetPropertiesInEditMode);

export const selectEditDatasetSection = createSelector(selectDatasetState, fromDataset.getEditDatasetSection);

export const selectShowNewFieldSelect = createSelector(selectDatasetState, fromDataset.getShowNewFieldSelect);

export const selectDataTypes = createSelector(selectDatasetState, fromDataset.getDataTypes);

export const selectDatasetDirty = createSelector(selectDatasetState, fromDataset.getDatasetDirty);

export const selectDatasetFields = createSelector(selectDatasetState, fromDataset.getDatasetFields);

export const selectSelectedDatasetField = createSelector(selectDatasetState, fromDataset.getSelectedDatasetField);

export const selectDatasetFieldForDelete = createSelector(selectDatasetState, fromDataset.getSelectedDatasetFieldForDelete);

export const selectDatasetsForSelect = createSelector(selectDatasetState, fromDataset.getDatasetsForSelect);

export const selectSelectedDatasetUID = createSelector(selectDatasetState, fromDataset.getSelectedDatasetUId);

export const selectShareSettingsQueryParams = createSelector(selectDatasetState, fromDataset.getShareSettingsQueryParams);

export const selectShareSettings = createSelector(selectDatasetState, fromDataset.getShareSettings);

export const selectAvailableSubscriptionQueryParams = createSelector(selectDatasetState, fromDataset.getAvailableSubscriptionQueryParams);

export const selectAvailableSubscriptions = createSelector(selectDatasetState, fromDataset.getAvailableSubscriptions);

/// Export Templates
export const selectExportTemplates = createSelector(selectDatasetState, fromDataset.getExportTemplates);

export const selectShowTemplateProperties = createSelector(selectDatasetState, fromDataset.getShowTemplateProperties);

export const selectSelectedTemplate = createSelector(selectDatasetState, fromDataset.getSelectedTemplate);

// translations
export const selectDatasetSchemaWithTranslations = createSelector(selectDatasetState, fromDataset.getDatasetSchemaWithTranslations);
export const selectSelectedDatasetFieldWithTranslations = createSelector(selectDatasetState, fromDataset.getSelectedDatasetFieldWithTranslations);
